const axios = require("axios")

async function getLeaderBoards(type) {

    return new Promise(
        async function (resolve) {
            const data = await axios.get(`${process.env.API_URL}/leaderboard/${type}`);
            resolve(data);
        }
    );
}

async function getHallOfFamer(type) {

    return new Promise(
        async function (resolve) {
            //replace this with actual api url for hall of famer.
            const data = await axios.get(`https://feed.swcpoker.club/krill/${type}/hof.json`);
            resolve(data);
        }
    );
}



export const leaderBoardService = {
    getLeaderBoards,
    getHallOfFamer
}